import React from 'react';

const ProductImageUploader = ({ 
  productImagePreviews, 
  setProductImagePreviews, 
  productImages, 
  setProductImages 
}) => {
  const handleAddImage = (e) => {
    if (e.target.files && e.target.files[0]) {
      const file = e.target.files[0];
      setProductImages(prev => [...prev, file]);

      const reader = new FileReader();
      reader.onload = (event) => {
        setProductImagePreviews(prev => [...prev, event.target.result]);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleRemoveImage = (idx) => {
    setProductImages(prev => prev.filter((_, i) => i !== idx));
    setProductImagePreviews(prev => prev.filter((_, i) => i !== idx));
  };

  return (
    <div className="sm:col-span-6 mt-6">
      <h4 className="text-sm font-medium text-gray-700 mb-4">Images du produit</h4>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
        {/* Image Preview Grid */}
        <div className="flex flex-wrap gap-4">
          {productImagePreviews.map((preview, idx) => (
            <div key={`preview-${idx}`} className="relative h-32 w-32">
              <img
                src={preview}
                alt={`Product preview ${idx + 1}`}
                className="h-32 w-32 rounded-lg object-cover border border-gray-200"
              />
              <button
                type="button"
                onClick={() => handleRemoveImage(idx)}
                className="absolute top-0 right-0 -mt-2 -mr-2 h-6 w-6 rounded-full bg-red-600 text-white flex items-center justify-center hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
              >
                <svg className="h-4 w-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
                <span className="sr-only">Supprimer l'image</span>
              </button>
            </div>
          ))}

          {/* Add Image Button */}
          <div className={`h-32 w-32 border-2 border-dashed border-gray-300 rounded-lg flex items-center justify-center ${productImagePreviews.length >= 5 ? 'opacity-50' : ''}`}>
            <label
              htmlFor="product-image"
              className={`cursor-pointer flex flex-col items-center ${productImagePreviews.length >= 5 ? 'cursor-not-allowed' : 'cursor-pointer'}`}
            >
              <svg className="h-8 w-8 text-gray-400" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
              </svg>
              <span className="mt-2 text-sm text-gray-500">
                {productImagePreviews.length >= 5 ? 'Maximum 5 images' : 'Ajouter une image'}
              </span>
              <input
                id="product-image"
                type="file"
                accept="image/*"
                className="sr-only"
                disabled={productImagePreviews.length >= 5}
                onChange={handleAddImage}
              />
            </label>
          </div>
        </div>

        <div className="text-sm text-gray-500 flex flex-col justify-center">
          <p className="mb-2"><strong>Instructions pour les images:</strong></p>
          <ul className="list-disc pl-5 space-y-1">
            <p>• Format recommandé: JPEG, PNG ou WebP</p>
            <p>• Taille maximale: 5 MB par image</p>
            <p>• Jusqu'à 5 images par produit</p>
            <p>• La première image sera utilisée comme image principale</p>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default ProductImageUploader;